/**
 * The sign-in providers a user's account can belong to. The backend's list is
 * backend/sign_in_providers.py PROVIDERS; `auth_type` on a user is one of
 * these ids, or 'jwt' for email and password.
 */
export const SIGN_IN_PROVIDER_LABELS = {
  google: 'Google',
  apple: 'Apple',
  microsoft: 'Microsoft',
};

/** 'Google', 'Apple' or 'Microsoft' for an account that signs in with one; else null. */
export function signInProviderLabel(authType) {
  return SIGN_IN_PROVIDER_LABELS[authType] || null;
}
